export const LOADING_COPY = {
	primary: "Loading your experience...",
	map: "Loading your experience...",
	mapTip: "Preparing your map and nearby drops...",
} as const;
